<template>
  <v-app>
    <v-card width="96%" class="mx-auto mt-5">
      <!-- <v-card-title class="pb-0">
        <h1>Login</h1>
      </v-card-title>-->
      <v-card-text>
        <v-form>
          <v-text-field
            v-model="password"
            :type="showPassword ? 'text' : 'password'"
            label="新パスワード"
            prepend-icon="lock"
            :append-icon="showPassword ? 'visibility' : 'visibility_off'"
            @click:append="showPassword = !showPassword"
          />
          <v-text-field
            v-model="confirmPassword"
            :type="showPassword ? 'text' : 'password'"
            label="新パスワード（確認用）"
            prepend-icon="lock"
            :append-icon="showPassword ? 'visibility' : 'visibility_off'"
            @click:append="showPassword = !showPassword"
          />
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn block color="#4C728A" dark v-on:click="changePassword()">パスワード変更</v-btn>
      </v-card-actions>
    </v-card>
  </v-app>
</template>

<script>
import { mapState } from 'vuex'
import ServerApiCallService from '@/services/ServerApiCallService.js'
export default {
  created() {
    ServerApiCallService.setAppJs(this.$parent.$parent.$parent)
  },
  components: {},
  computed: {
    ...mapState({
      user: state => state.user
    })
  },
  data() {
    return {
      password: '',
      confirmPassword: '',
      showPassword: false
    }
  },
  methods: {
    changePassword() {
      console.log('change password')

      if (!this.password) {
        alert('パスワードを入力してください')
        return false;
      }
      if (!this.confirmPassword) {
        alert('確認用のパスワードを入力してください')
        return false;
      }
      if (this.password.length < 5) {
        alert('4桁以上入力してください')
        return false;
      }
      if (this.confirmPassword.length < 5) {
        alert('4桁以上入力してください')
        return false;
      }
      if (this.user.userId == this.password) {
        alert('ユーザーIDと同じパスワードは使えません')
        return false;
      }
      if (this.confirmPassword != this.password) {
        alert('パスワードが一致していません')
        return false;
      }      

      let request = {
        password: this.password,
        confirmPassword: this.confirmPassword
      }
      let sendContext = {
        hasDialogComponent: this.$parent.$parent.$parent,
        callbackAfterOnClose: function(response) {
          // TODO 応急処置。あとでセキュリティ性を高める
          if (this.$route.params.fromAdminLogin) {
            // パスワード変更
            this.$router.push({
              name: 'admin/new-admin-menu'
            })
          } else {
            // メニュー画面
            this.$router.push({
              name: 'sales/new-user-menu'
            })
          }
        }
      }

      ServerApiCallService.usersPasswordChange(request, sendContext)
        .then(response => {})
        .catch(error => {
          console.log('There was an error:', error.response)
        })
    }
  }
}
</script>
